import React from 'react';
import { Select } from 'antd';

import { choicesOf } from '../../utils/changeCard/compat';
import { LEAVE_EMPTY } from './changeCardModel';

/**
 * The second step of a choice target (KPR-707): each of the source's choices
 * goes to one of the target's, or is left empty. It starts from the table's
 * suggestion (same stored value, then same label); a choice the suggestion
 * could not place stays unpicked, and the dry run counts the items holding it
 * until the person picks.
 */
export default function ChoiceMapEditor({ source, target, choices, onChange }) {
	const targetOptions = [
		...choicesOf(target).map(c => ({ value: c.value, label: c.label })),
		{ value: LEAVE_EMPTY, label: 'Leave empty' },
	];
	return (
		<ul className="change-card__choice-map" aria-label="Map choices">
			{choicesOf(source).map(choice => {
				const has = Object.prototype.hasOwnProperty.call(choices, choice.value);
				return (
					<li key={choice.value} className="change-card__choice-row">
						<span className="change-card__choice-from">{choice.label}</span>
						<Select
							size="small"
							className="change-card__choice-to"
							placeholder="Choose"
							value={has ? choices[choice.value] : undefined}
							options={targetOptions}
							onChange={value => onChange({ ...choices, [choice.value]: value })}
							aria-label={`${choice.label} becomes`}
							popupMatchSelectWidth={false}
						/>
					</li>
				);
			})}
		</ul>
	);
}
